<template>
	<div class="bottom-payment">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="closeBottomSheet">
			<div class="bottom-payment-content" v-if="active">
				<div class="wrapper-buttons-add mb-10" v-show="!hideCustomerPicker">
					<div class="row-button-add">
						<AppButton icon-left="Icon-User-blue" small outline :text="getString('person')" @click="openPersonSheet"/>
						<AppButton icon-left="Icon-Company-blue" small outline :text="getString('company')" @click="openCompanySheet"/>
						<AppButtonIcon prevent-change icon-name="icon-qr-scan-white" @click-icon="counterStore.qrScannerActive = true"/>
					</div>
				</div>
				<CustomersDisplay @deleted-customer="emitDeletedCustomer" @deleted-company="emitDeletedCompany" v-if="!noCustomer"
								  :is-registry="isRegistry" :is-orders="isOrders" :not-editable="customerNotEditable"/>
				<div class="container-payment-status mb-10">
					<div class="column-status" :class="{clickable: !noTotalDiscount}" @click="discountToggle">
						<div class="column-status-name">{{ getString('total_x', [currencyStore.currCurrency.symbol]) }}</div>
						<div class="column-status-value mt-10">{{ currencyStore.readableCurrencyValue(total, true, false) }}</div>
					</div>
					<div class="alignment-cta">
						<div class="column-status status-paid">
							<div class="column-status-name">{{ getString('paid_x', [currencyStore.currCurrency.symbol]) }}</div>
							<div class="column-status-value">{{ currencyStore.readableCurrencyValue(paidValue, true, false) }}</div>
						</div>
						<div class="column-status status-topay" :class="{discounted: discountOnTotal}">
							<div class="column-status-name" v-if="!discountOnTotal">
								{{ getString('to_pay_x', [currencyStore.currCurrency.symbol]) }}
							</div>
							<div class="column-status-value" v-if="!discountOnTotal">
								{{ currencyStore.readableCurrencyValue(toPayValue, true, false) }}
							</div>

							<p class="split-row-label" v-if="discountOnTotal">
								{{ getString('to_pay_x', [currencyStore.currCurrency.symbol]) }}
							</p>
							<div class="full-total-container" v-if="discountOnTotal">
								<p class="full-total">{{ strikethroughAmount }}</p>
							</div>
							<div class="discounted-total-container" v-if="discountOnTotal">
								<p class="discounted-total mr-6">{{ readableToPayValue }}</p>
								<div class="icon-discount" v-html="svgStore.get('iconCoupons')"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="payment-type-container" v-if="itemsSplit !== null">
					<div class="wrapper-tabbar">
						<div v-for="(button, index) in buttons" :key="index" @click="changePaymentMode(index)" class="botton-tabbar"
							 :class="{ 'active': chosenPaymentMode === index, border: 0 === index && onlyTotalItem }">
							<p>{{ 0 === index && onlyTotalItem ? totalItemTitle : button.text }}</p>
							<div class="indicator-bar"></div>
						</div>
					</div>
				</div>
				<AppDropdown square-corner :collapsed="chosenPaymentMode !== 1" white>
					<div class="payment-advance-container mb-10">
						<TouchNumberInput
							:min="0"
							:label="getString('partial_amount', [currencyStore.currCurrency.symbol])"
						  	:max="currencyStore.dbToActualValue(toPayValue)"
							:double-decimal="currencyStore.currCurrency.decimals === 2"
							:value="currencyStore.dbToActualValue(intentToPay)"
							@changedValue="changePartial"
						/>
					</div>
				</AppDropdown>
				<AppDropdown square-corner :collapsed="chosenPaymentMode !== 2" white>
					<div class="payment-dutch-container mb-10">
						<div class="row-dutch">
							<div class="num-people-container" @click="dutchMultiActive = true">
								<p v-if="dutchPeopleMulti > 1">{{ 'x' + dutchPeopleMulti }}</p>
								<div class="num-people" v-html="svgStore.get('iconUser')"></div>
							</div>
							<TouchNumberInput :label="getString('num_people')" :min="1" :max="Math.min(currencyStore.currMinInteger, toPayValue)"
											  :value="dutchPeople" @changedValue="changeDutch"/>
							<div class="dutch-value-container">
								<p class="dutch-label" v-if="dutchPeopleMulti > 1">
									<span>{{ currencyStore.readableCurrencyValue(dutchPeopleMultiSingleShare) }}</span>
									{{ getString('amount_per_person') }}
								</p>

								<div class="split-row-value"
									 :class="{clickable: intentToPay > 0, discounted: discountedItemsSplitTotal !== null || paymentItemsSplitTotal !== null}"
									 @click="editSplitTotalValue"
								>
									<p class="split-row-label">{{ getString('amount_x', [currencyStore.currCurrency.symbol]) }}</p>
									<p class="selected-total" v-if="discountedItemsSplitTotal !== null || paymentItemsSplitTotal !== null">
										{{ currencyStore.readableCurrencyValue(intentToPay, true, false) }}</p>
									<div class="full-total-container">
										<p class="full-total">{{ currencyStore.readableCurrencyValue(finalAmountDutch, true, false) }}</p>
										<div class="icon-discount" v-if="discountedItemsSplitTotal !== null && paymentItemsSplitTotal === null" v-html="svgStore.get('iconCoupons')"></div>
									</div>
									<div class="discounted-total-container" v-if="paymentItemsSplitTotal !== null && discountedItemsSplitTotal !== null">
										<p class="discounted-total">{{ currencyStore.readableCurrencyValue(discountedItemsSplitTotal) }}</p>
										<div class="icon-discount" v-html="svgStore.get('iconCoupons')"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</AppDropdown>
				<AppDropdown square-corner :collapsed="chosenPaymentMode !== 3" white>
					<div class="payment-split-container">
						<div class="payment-split-row-title split-row-choose-title">
							<div class="split-title">{{ getString('ordered_products') }}</div>
						</div>
						<div class="payment-split-row split-row-choose">
							<div class="split-row-items">
								<BottomPaymentSplitItem v-for="item in itemsSplitChoosable" :key="item.id" :item="item" :quantity="getItemAvailable(item)"
														@click="clickChoosableItem(item)" @long-click="longClickItem(item)"/>
							</div>
						</div>
						<div class="payment-split-row-title split-row-chosen-title">
							<div class="split-title">{{ getString('selected_products') }}</div>
							<div class="split-overflow" v-if="itemsSplitSelectedTotalOverflow > 0">{{
									getString('overflow_amount')
								}}<span>{{ currencyStore.readableCurrencyValue(itemsSplitSelectedTotalOverflow) }}</span></div>
						</div>
						<div class="payment-row-wrapper">
							<div class="payment-split-row split-row-chosen">
								<div class="split-row-items">
									<BottomPaymentSplitItem v-for="item in itemsSplitSelected" :key="item.id" :item="item" :quantity="getItemSelectedQuantity(item)"
															selected
															@click="clickChosenItem(item)" @long-click="longClickItem(item)"/>
								</div>
							</div>
							<div class="split-row-value"
								 :class="{clickable: itemsSplitSelectedTotal > 0, discounted: discountedItemsSplitTotal !== null || paymentItemsSplitTotal !== null}"
								 @click="editSplitTotalValue">
								<p class="split-row-label">{{ getString('amount_x', [currencyStore.currCurrency.symbol]) }}</p>
								<p class="selected-total" v-if="discountedItemsSplitTotal !== null || paymentItemsSplitTotal !== null">
									{{ currencyStore.readableCurrencyValue(itemsSplitSelectedTotal, true, false) }}</p>
								<div class="full-total-container">
									<p class="full-total">{{ currencyStore.readableCurrencyValue(finalAmountSplit, true, false) }}</p>
									<div class="icon-discount" v-if="discountedItemsSplitTotal !== null && paymentItemsSplitTotal === null" v-html="svgStore.get('iconCoupons')"></div>
								</div>
								<div class="discounted-total-container" v-if="paymentItemsSplitTotal !== null && discountedItemsSplitTotal !== null">
									<p class="discounted-total">{{ currencyStore.readableCurrencyValue(discountedItemsSplitTotal) }}</p>
									<div class="icon-discount" v-html="svgStore.get('iconCoupons')"></div>
								</div>
							</div>
						</div>
					</div>
				</AppDropdown>
				<div class="payment-buttons" v-if="!loadingPayment">
					<div class="main-payment-buttons" v-if="!showPayWithCreditButton">
						<div class="payment-button" :class="{'full-width': !userStore.checkOrderPayPosAllowed, 'cash-over-limit': userStore.isOverCashLimit}" @click="startPayment('cash')" v-if="userStore.checkOrderPayCashAllowed">
							<p>{{ getString('cash') }}</p>
							<div class="payment-shortcut" v-html="svgStore.get(cashButtonIcon)" @click.stop="startPayment('cash-fast')"></div>
						</div>
						<div class="payment-button" :class="{'full-width': !userStore.checkOrderPayCashAllowed}" @click="startPayment('pos')" v-if="userStore.checkOrderPayPosAllowed">
							<p>{{ getString('cards') }}</p>
							<div class="payment-shortcut" v-if="getDefaultTerminal() !== null" v-html="svgStore.get('iconPos')"
								 @click.stop="startPayment('pos-fast')"></div>
						</div>
					</div>
					<div class="payment-button credit-button full-width" @click="startPayment('customer_credit')" v-if="showPayWithCreditButton">
						<p>{{ getString('pay_with_credit') }}</p>
					</div>
					<div class="payment-button" @click="startPayment('other')" v-if="!showPayWithCreditButton && userStore?.currSubscription !== 'free' && otherMethods > 0 && userStore.checkOrderPayOtherAllowed"><p>{{ getString('other') }}</p></div>
				</div>
				<div class="loader-container" v-else>
					<AppLoader/>
				</div>
				<BottomCashPayment :active="activeCash" @toggling-popup="togglingCash" @payment-done="paymentComplete('cash')"
								   :to-pay="currentIntentToPay"/>
				<BottomCashmaticPayment :active="activeCashmatic" @toggling-popup="togglingCashmatic" @payment-done="paymentComplete('cash')"
								   :to-pay="currentIntentToPay"/>
				<BottomCardPayment :active="activeCard" @refresh-terminals="addedLocalTerminal" @toggling-popup="togglingCard" @payment-done="paymentComplete('external')"
								   @start-payment="startPosPayment" :terminals="terminals" :amount-to-pay="currentIntentToPay"/>
				<BottomOtherPayment :is-registry="isRegistry" :no-pay-later="noPayLater || chosenPaymentMode !== 0" :active="activeOther"
									@toggling-popup="togglingOther" @payment-done="paymentComplete"/>
				<PhysicalPosContainer v-if="terminals.length > 0" ref="pos-container" manual-triggering :manual-terminal-id="getDefaultTerminal()"
									  @payment-success="(orderId, paymentType) => paymentComplete(paymentType, orderId)" @payment-failed="loadingPayment = false"
									  no-hide-mobile no-stats/>
			</div>
		</AppBottomSheet>
		<div class="sheets" v-if="active">
			<AppBottomSheet :active="dutchMultiActive" :force-width="bottomSheetWidthSmall" @toggling-popup="toggleDutchMulti">
				<ModalHeader :title="getString('more_shares_payment')" :button-text="getString('confirm')" @click-button="dutchMultiActive = false"/>
				<div class="shares-container">
					<p>{{ getString('shares_to_pay') }}</p>
					<TouchNumberInput :min="1" :max="dutchPeople" :value="dutchPeopleMulti" @changedValue="changeDutchMulti"/>
				</div>
			</AppBottomSheet>
			<AppPopup ref="popup-partial" :title="getString('discount_or_partial_payment')" :body-text="getString('discount_or_partial_payment_body')"
					  :buttons="discountPartialButtons"/>
			<CustomersPicker ref="customer-picker" :active="customerPicker" @person-open-picker="personHandleOpenPicker"
							 @company-open-picker="companyHandleOpenPicker" @toggling-popup="togglingCustomersPicker"
							 @picked-customer="pickedCustomer"/>
			<BottomNumberEditor only-decrement :custom-shortcuts="!discountMode"
								:active="splitPayEdit"
								:title="discountOrSplitTitle"
								:start-price-name="getString('price')"
								:starting-number="startingNumber"
								:no-hundred-percent="noHundredPercent"
								:discount-mode="discountMode"
								@toggling-popup="togglingEditSplit"
								@confirm-number="confirmPrice"/>
			<BottomNumberEditor only-decrement :active="ghostProductEdit" :title="getString('amount_left_x', [currencyStore.currCurrency.symbol])"
								:start-price-name="getString('amount_left')" :starting-number="ghostFullAmount" @toggling-popup="togglingGhostEdit"
								@confirm-number="confirmGhostPrice"/>
			<ItemProductsExplain :items="itemsSplit || []" :selectedItems="selectedItems" :menu-item-id="activeExplainItemProducts"
								 :active="activeExplainItemProducts !== null" @toggle-close="toggleItemProductExplain"
								 @increase-selected="clickChoosableItem" @decrease-selected="clickChosenItem"/>
		</div>
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import BottomCashPayment from "@/console-new/components/ops/counter/BottomCashPayment.vue";
import BottomCashmaticPayment from "@/console-new/components/ops/counter/BottomCashmaticPayment.vue";
import PhysicalPosContainer from "@/console-pos/components/PhysicalPosContainer.vue";
import {useCounterStore, useOrdersActionsStore, useOrdersStore, useUserStore} from "@/console-new/stores";
import BottomCardPayment from "@/console-new/components/ops/counter/BottomCardPayment.vue";
import SuggestionsList from "@/console-new/components/ops/counter/SuggestionsList.vue";
import BottomOtherPayment from "@/console-new/components/ops/counter/BottomOtherPayment.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import TouchNumberInput from "@/console-new/components/shared/TouchNumberInput.vue";
import BottomPaymentSplitItem from "@/console-new/components/ops/counter/BottomPaymentSplitItem.vue";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import CustomersPicker from "@/console-new/components/ops/CustomersPicker.vue";
import CustomersDisplay from "@/console-new/components/ops/CustomersDisplay.vue";
import BottomNumberEditor from "@/console-new/components/ops/counter/BottomNumberEditor.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import ItemProductsExplain from "@/console-new/components/ops/counter/ItemProductsExplain.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import {isAndroid} from "@/shared/helpers/webapp";

const discountModes = {
	total: 'total',
	split: 'split',
}

export default {
	setup() {
		let languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		const userStore = useUserStore();
		const counterStore = useCounterStore();
		const ordersStore = useOrdersStore();
		const ordersActionsStore = useOrdersActionsStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		return {
			getString: languageStore.getString,
			svgStore,
			userStore,
			currencyStore,
			ordersStore,
			counterStore,
			notificationStore,
			ordersActionsStore,
		};
	},
	name: "BottomPayment",
	components: {
		AppPopup,
		ItemProductsExplain,
		AppDropdown,
		AppButton,
		AppButtonIcon,
		BottomNumberEditor,
		CustomersDisplay,
		CustomersPicker,
		TouchNumberInput,
		AppTextInput,
		SuggestionsList,
		AppGoogleMapsInput,
		BottomPaymentSplitItem,
		AppLoader,
		PhysicalPosContainer, BottomCashPayment, BottomCashmaticPayment, AppRadioButtonGroup, ModalHeader, AppBottomSheet, BottomCardPayment, BottomOtherPayment
	},
	emits: ["toggling-popup", "payment-done", "deleted-customer", "deleted-company"],
	mixins: [WindowWidth],
	data() {
		return {
			onlyTotalItem: false,
			customerPicker: false,
			activeCash: false,
			activeCashmatic: false,
			cashmaticPaymentProcessed: false,
			activeCard: false,
			activeOther: false,
			terminals: [],
			chosenPaymentMode: 0,
			intentToPay: 0,
			dutchPeople: 2,
			dutchPeopleMulti: 1,
			dutchMultiActive: false,
			selectedItems: [],
			loadingPayment: false,
			splitPayEdit: false,
			ghostProductEdit: false,
			discountedItemsSplitTotal: null,
			paymentItemsSplitTotal: null,
			forceModeAfterPayment: false,
			ghostSelectedTotal: 0,
			selectedButton: 'total',
			buttons: [
				{text: this.getString('total'), value: 'total'},
				{text: this.getString('partial'), value: 'partial'},
				{text: this.getString('go_dutch'), value: 'go_dutch'},
				{text: this.getString('split'), value: 'split'}
			],
			activeExplainItemProducts: null,
			discountMode: null,
			discountOnTotal: 0,
			appliedCoupons: null,
		}
	},
	props: {
		active: {
			type: Boolean,
			required: true,
		},
		total: {
			type: Number,
			required: true,
		},
		paidValue: {
			type: Number,
			default: 0,
		},
		itemsSplit: {
			type: Array,
			default: [],
			validator: (value) => {
				return value.every(item => item.hasOwnProperty("name") && item.hasOwnProperty("price") && item.hasOwnProperty("quantity") && item.hasOwnProperty("id"));
			},
		},
		noPayLater: {
			type: Boolean,
			default: false,
		},
		hideCustomerPicker: {
			type: Boolean,
			default: false,
		},
		customerNotEditable: {
			type: Boolean,
			default: false,
		},
		noCustomer: {
			type: Boolean,
			default: false,
		},
		isCounter: {
			type: Boolean,
			default: false,
		},
		isRegistry: {
			type: Boolean,
			default: false,
		},
		isOrders: {
			type: Boolean,
			default: false,
		},
		defaultDutchPeople: {
			type: Number,
			default: 2,
		},
		skipTipping: {
			type: Boolean,
			default: false
		},
		noTotalDiscount: {
			type: Boolean,
			default: false,
		}
	},
	computed: {
		totalItemTitle() {
			return this.userStore.currBusiness?.counter_total_title || 'Pasto completo';
		},
		discountPartialButtons() {
			return [
				{
					text: this.getString('discount'),
					callback: () => {
						this.$refs["popup-partial"].toggleStatus(false);
						this.discountMode = discountModes.split;
						this.splitPayEdit = true;
					},
				},
				{
					text: this.getString('partial'),
					callback: () => {
						this.$refs["popup-partial"].toggleStatus(false);
						this.discountMode = null;
						this.splitPayEdit = true;
					},
				},
			]
		},
		dutchPeopleMultiSingleShare() {
			return this.intentToPay / (this.dutchPeopleMulti > 0 ? this.dutchPeopleMulti : 1);
		},
		toPayValue() {
			return this.total - this.paidValue - this.discountOnTotal;
		},
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		bottomSheetWidthSmall() {
			if (this.windowWidth < 550) {
				return "100%";
			} else {
				return "550px";
			}
		},
		currentIntentToPay() {
			if (this.chosenPaymentMode === 0) {
				return this.toPayValue;
			} else if (this.chosenPaymentMode === 2) {
				let value = this.intentToPay;
				if (this.discountedItemsSplitTotal) {
					value = this.discountedItemsSplitTotal;
				}
				if (this.paymentItemsSplitTotal) {
					value = this.paymentItemsSplitTotal;
				}
				return value > this.toPayValue ? this.toPayValue : value;
			} else if (this.chosenPaymentMode === 3) {
				let value = this.itemsSplitSelectedTotal;
				if (this.discountedItemsSplitTotal) {
					value = this.discountedItemsSplitTotal;
				}
				if (this.paymentItemsSplitTotal) {
					value = this.paymentItemsSplitTotal;
				}
				return value > this.toPayValue ? this.toPayValue : value;
			} else {
				return this.intentToPay;
			}
		},
		itemsSplitChoosable() {
			if (!this.itemsSplit) {
				return [];
			}

			let itemsSplitChoosable = [];
			let itemsSplitChoosableWithDifferentVariations = this.itemsWithDifferentVariations;

			for (let i = 0; i < this.itemsSplit.length; i++) {
				let item = this.itemsSplit[i];
				let itemQuantity = this.getItemAvailable(item);
				if (itemQuantity > 0) {
					itemsSplitChoosable.push({
						...item,
						differentVariations: itemsSplitChoosableWithDifferentVariations[item.menu_item_id]
					});
				}
			}
			let ghostAmount = this.ghostProductAmount;
			if (ghostAmount > 0) {
				itemsSplitChoosable.push({
					id: "ghost",
					name: this.getString("amount_left"),
					price: ghostAmount,
					quantity: 1,
					selected: 0,
					redeemed: 0,
				});
			}
			return itemsSplitChoosable;
		},
		ghostFullAmount() {
			if (!this.itemsSplit) {
				return 0;
			}
			let total = 0;
			for (let i = 0; i < this.itemsSplit.length; i++) {
				let item = this.itemsSplit[i];
				let itemQuantity = this.getItemAvailable(item);
				if (itemQuantity > 0) {
					total += itemQuantity * item.price;
				}
			}
			this.itemsSplit.forEach(item => {
				let selected = this.getItemSelectedQuantity(item);
				if (selected > 0) {
					total += selected * item.price;
				}
			});
			return this.toPayValue - total;
		},
		ghostProductAmount() {
			return this.ghostFullAmount - this.ghostSelectedTotal;
		},
		itemsSplitSelected() {

			if (!this.itemsSplit) {
				return [];
			}

			let selectedItems = [];
			let selectedItemsWithDifferentVariations = this.itemsWithDifferentVariations;

			this.itemsSplit.forEach(item => {
				let selected = this.getItemSelectedQuantity(item);
				if (selected > 0) {
					selectedItems.push({
						...item,
						differentVariations: selectedItemsWithDifferentVariations[item.menu_item_id]
					});
				}
			});
			if (this.ghostSelectedTotal > 0) {
				selectedItems.push({
					id: "ghost",
					name: this.getString("amount_left"),
					price: this.ghostSelectedTotal,
					quantity: 1,
					selected: 1,
					redeemed: 0
				});
			}
			return selectedItems;
		},
		itemsSplitSelectedTotal() {
			return this.itemsSplitSelected.reduce((acc, item) => {
				let selected = this.getItemSelectedQuantity(item);
				return acc + (selected * item.price);
			}, 0);
		},
		itemsSplitSelectedTotalOverflow() {
			let value = this.itemsSplitSelectedTotal;
			if (this.discountedItemsSplitTotal) {
				value = this.discountedItemsSplitTotal;
			}
			if (this.paymentItemsSplitTotal) {
				value = this.paymentItemsSplitTotal;
			}
			return this.toPayValue >= value ? 0 : value - this.toPayValue;
		},
		readableFullTotal() {
			let itemTot = this.itemsSplitSelectedTotal;
			if (this.discountedItemsSplitTotal) {
				itemTot = this.discountedItemsSplitTotal;
			}
			if (this.paymentItemsSplitTotal) {
				itemTot = this.paymentItemsSplitTotal;
			}
			if (itemTot > this.toPayValue) {
				return this.currencyStore.readableCurrencyValue(this.toPayValue);
			}
			return this.currencyStore.readableCurrencyValue(itemTot, true, false);
		},
		readableFullTotalDutch() {
			let itemTot = this.intentToPay;
			if (this.discountedItemsSplitTotal) {
				itemTot = this.discountedItemsSplitTotal;
			}
			if (this.paymentItemsSplitTotal) {
				itemTot = this.paymentItemsSplitTotal;
			}
			if (itemTot > this.toPayValue) {
				return this.currencyStore.readableCurrencyValue(this.toPayValue);
			}
			return this.currencyStore.readableCurrencyValue(itemTot, true, false);
		},
		itemsWithDifferentVariations() {
			let itemIds = {};

			this.itemsSplit.forEach(currItem => {

				if (!itemIds[currItem.menu_item_id]) {
					itemIds[currItem.menu_item_id] = false;

					let otherItem = this.itemsSplit.find(item => item.menu_item_id === currItem.menu_item_id && item.id !== currItem.id);
					if (otherItem !== undefined) {

						if (otherItem?.products?.length && otherItem?.products?.length === currItem?.products?.length) {

							for (let i = 0; i < currItem.products.length; i++) {
								const currItemProduct = currItem.products[i];

								let itemProductCheck = otherItem.products.find(otherItemProduct => otherItemProduct.menu_item_list_product_id === currItemProduct.menu_item_list_product_id && otherItemProduct.quantity === currItemProduct.quantity);

								if (itemProductCheck === undefined) {
									itemIds[currItem.menu_item_id] = true;
									break;
								}
							}

						} else {
							itemIds[currItem.menu_item_id] = true;
						}

					}
				}

			});

			return itemIds;
		},
		otherMethods() {
			let counter = 0;
			if (this.userStore.currBusiness) {
				if (this.userStore.currBusiness.counter_pay_later) {
					counter++;
				}
				if (this.userStore.currBusiness.counter_ticket) {
					counter++;
				}
				if (this.userStore.currBusiness.counter_satispay && this.userStore.currBusiness.country === 'IT') {
					counter++;
				}
				if (this.userStore.currBusiness.counter_wire_transfer) {
					counter++;
				}
				if (this.userStore.currBusiness.counter_check) {
					counter++;
				}
				if (this.userStore.currBusiness.counter_manual && !this.counterStore.creditTopUpMode) {
					counter++;
				}
			}

			return counter;
		},
		discountOrSplitTitle() {
			let stringKey = "discount_pay_amount";
			let amount = this.total;
			if (this.discountMode !== discountModes.total) {
				stringKey = "split_pay_amount";

				if (this.chosenPaymentMode === 2) {
					amount = this.intentToPay;
				} else if (this.discountMode === discountModes.split && this.itemsSplitSelectedTotal > this.toPayValue) {
					amount = this.toPayValue
				} else {
					amount = this.itemsSplitSelectedTotal > this.toPayValue ? this.toPayValue : this.itemsSplitSelectedTotal;
				}

			}
			return this.getString(stringKey, [this.currencyStore.readableCurrencyValue(amount)]);
		},
		startingNumber() {
			if (this.discountMode && this.discountMode === discountModes.total) {
				return this.total - this.paidValue;
			} else if (this.chosenPaymentMode === 2) {
				return this.intentToPay;
			} else if (this.discountMode === discountModes.split && this.itemsSplitSelectedTotal > this.toPayValue) {
				return this.toPayValue
			} else {
				return this.itemsSplitSelectedTotal > this.toPayValue ? this.toPayValue : this.itemsSplitSelectedTotal;
			}
		},
		noHundredPercent() {
			return this.discountMode && this.discountMode !== discountModes.total;
		},
		availableCustomerCredit() {
			if(this.counterStore.creditTopUpMode) {
				return 0;
			}
			const customer = this.isRegistry ? this.counterStore?.registryEditingCustomer : this.counterStore?.selectedCustomer;
			return customer?.credit || 0;
		},
		showPayWithCreditButton() {
			if(this.counterStore.creditTopUpMode || !this.userStore.checkOrderPayOtherAllowed) {
				return false;
			}
			const credit = this.availableCustomerCredit;
			let hasCredit = !!credit && credit > 0;
			return hasCredit && (!this.isRegistry || credit >= this.toPayValue)
		},
		strikethroughAmount() {
			// The original amount before any deductions
			return this.currencyStore.readableCurrencyValue(this.total - this.paidValue, true, false);
		},
		readableToPayValue() {
			// The final amount after discount deductions
			return this.currencyStore.readableCurrencyValue(this.toPayValue, true, false);
		},
		finalAmountDutch() {
			// Final amount for Dutch mode after edits and credit
			let amount = this.intentToPay;
			if (this.discountedItemsSplitTotal !== null) {
				amount = this.discountedItemsSplitTotal;
			}
			if (this.paymentItemsSplitTotal !== null) {
				amount = this.paymentItemsSplitTotal;
			}
			if (amount > this.toPayValue) {
				amount = this.toPayValue;
			}
			return Math.max(0, amount);
		},
		finalAmountSplit() {
			// Final amount for Split mode after edits and credit
			let amount = this.itemsSplitSelectedTotal;
			if (this.discountedItemsSplitTotal !== null) {
				amount = this.discountedItemsSplitTotal;
			}
			if (this.paymentItemsSplitTotal !== null) {
				amount = this.paymentItemsSplitTotal;
			}
			if (amount > this.toPayValue) {
				amount = this.toPayValue;
			}
			return Math.max(0, amount);
		},
		cashButtonIcon() {
			if(isAndroid() && localStorage.getItem("cashmaticActive") === "1") {
				return 'iconCashmatic';
			}
			return 'iconCash';
		}
	},
	methods: {
		toggleDutchMulti(v) {
			if (!v) {
				this.dutchMultiActive = false;
			}
		},
		togglingEditSplit(v) {
			if (!v) {
				this.splitPayEdit = false;
			}
		},
		togglingGhostEdit(v) {
			if (!v) {
				this.ghostProductEdit = false;
			}
		},
		confirmPrice(v, appliedCoupons) {
			this.splitPayEdit = false;
			this.appliedCoupons = null;
			let refTotal = this.itemsSplitSelectedTotal;
			if (this.chosenPaymentMode === 2) {
				refTotal = this.intentToPay;
			} else if (this.discountMode === discountModes.split && this.itemsSplitSelectedTotal > this.toPayValue) {
				refTotal = this.toPayValue;
			}
			if (this.discountMode) {
				if (this.discountMode === discountModes.total) {
					if (v < this.total) {
						this.appliedCoupons = appliedCoupons;
						this.discountOnTotal = this.total - this.paidValue - v;
						this.discountedItemsSplitTotal = null;
						this.paymentItemsSplitTotal = null;
					} else {
						this.discountOnTotal = 0;
					}
				} else if (this.discountMode === discountModes.split) {
					if (v < refTotal) {
						if (this.paymentItemsSplitTotal !== null && v <= this.paymentItemsSplitTotal) {
							this.paymentItemsSplitTotal = null;
						}
						this.discountedItemsSplitTotal = v;
					} else {
						this.discountedItemsSplitTotal = null;
					}

				}
			} else {
				if (v < refTotal) {
					if (this.discountedItemsSplitTotal !== null && v >= this.discountedItemsSplitTotal) {
						this.discountedItemsSplitTotal = null;
					}
					this.paymentItemsSplitTotal = v;
				} else {
					this.paymentItemsSplitTotal = null;
				}
			}
		},
		confirmGhostPrice(v) {
			this.ghostProductEdit = false;
			if (v <= this.ghostFullAmount) {
				this.ghostSelectedTotal = v;
			} else {
				this.ghostSelectedTotal = null;
			}
		},
		editSplitTotalValue() {
			if (this.userStore.checkOrderDiscountAllowed) {
				if (this.chosenPaymentMode === 2) {
					if (this.intentToPay > 0) {
						this.$refs["popup-partial"].toggleStatus(true);
					}
				} else {
					if (this.itemsSplitSelectedTotal > 0) {
						this.$refs["popup-partial"].toggleStatus(true);
					}
				}
			} else {
				this.discountMode = null;
				this.splitPayEdit = true;
			}
		},
		togglingCustomersPicker(v) {
			if (!v) {
				this.customerPicker = false;
			}
		},
		pickedCustomer(customer) {
			this.customerPicker = false;
			this.counterStore.selectedCustomer = customer;
		},
		getItemSelectedQuantity(item) {
			if (item.id === "ghost") {
				return this.ghostSelectedTotal > 0 ? 1 : 0;
			}
			let selectedItem = this.getItemSelected(item);
			return selectedItem !== undefined ? selectedItem.selected : 0;
		},
		getItemAvailable(item) {
			let selectedItem = this.getItemSelected(item);
			return selectedItem !== undefined ? item.quantity - item.redeemed - selectedItem.redeemed - selectedItem.selected : item.quantity - item.redeemed;
		},
		getItemSelected(item) {
			return this.selectedItems.find(i => i.id === item.id);
		},
		clickChoosableItem(item) {
			this.discountedItemsSplitTotal = null;
			this.paymentItemsSplitTotal = null;
			if (item.id === "ghost") {
				this.ghostProductEdit = true;
				return;
			}
			let selectedItem = this.getItemSelected(item);
			let selected = selectedItem !== undefined ? selectedItem.selected : 0;
			if (selected >= item.quantity) {
				return;
			}
			/*let wantToPay = item.price+this.itemsSplitSelectedTotal;
			let delta = Math.abs(this.toPayValue-wantToPay);
			let numItemsLeft = this.itemsSplitChoosableNum;
			let approximateToEndPayment = delta < 2 && numItemsLeft <= 1;
			if(wantToPay > this.toPayValue && !approximateToEndPayment) {
				this.notificationStore.showNotification("split-overflow");
				return;
			}*/
			if (selectedItem) {
				selectedItem.selected++;
			} else {
				let orderItemId = null;
				if (item.hasOwnProperty("order_item_id")) {
					orderItemId = item.order_item_id;
				}
				let menuItemId = null;
				if (item.hasOwnProperty("menu_item_id")) {
					menuItemId = item.menu_item_id;
				}
				this.selectedItems.push({
					id: item.id,
					order_item_id: orderItemId,
					menu_item_id: menuItemId,
					order_id: item.order_id ? item.order_id : null,
					selected: 1,
					redeemed: 0
				});
			}
			this.intentToPay = this.itemsSplitSelectedTotal;
		},
		clickChosenItem(item) {
			this.discountedItemsSplitTotal = null;
			this.paymentItemsSplitTotal = null;
			if (item.id === "ghost") {
				this.ghostSelectedTotal = 0;
				return;
			}
			let selectedItem = this.getItemSelected(item);
			if (selectedItem) {
				selectedItem.selected--;
				if (selectedItem.selected === 0) {
					this.selectedItems = this.selectedItems.filter(i => i.id !== item.id);
				}
			}
			this.intentToPay = this.itemsSplitSelectedTotal;
		},
		longClickItem(itemValue) {
			//if(this.itemsSplit.filter(item => item.products.length > 0).length > 0){
			if (itemValue.differentVariations) {
				this.activeExplainItemProducts = itemValue.menu_item_id;
			}
		},
		changePaymentMode(index) {
			let startingPM = this.chosenPaymentMode;
			this.chosenPaymentMode = index;
			this.forceModeAfterPayment = false;
			if(index === 0) {
				if(startingPM === 0) {
					if(!this.onlyTotalItem) {
						let hasMultipleOrders = (this.ordersActionsStore.ordersPayment?.length || 0) > 1;
						let hasMultiplePayments = this.ordersActionsStore.ordersPayment?.[0]?.payments?.length;
						if(!hasMultipleOrders && !hasMultiplePayments) {
							this.onlyTotalItem = true;
						} else {
							this.notificationStore.showNotification("no-receipt-single-item");
						}
					} else {
						this.onlyTotalItem = false;
					}
				} else {
					this.onlyTotalItem = false;
				}

			} else {
				this.onlyTotalItem = false;
				if (index === 2) {
					this.changeDutch(this.dutchPeople);
				} else if (index === 3) {
					this.paymentItemsSplitTotal = null;
					this.discountedItemsSplitTotal = null;
				}
			}
		},
		startPayment(mode) {

			if (mode === "cash") {
				if (this.userStore.isOverCashLimit) {
					let maxFreeCashAmount = this.currencyStore.currCurrency?.max_free_weekly_cash_amount || 300000;
					let formattedMaxCash = this.currencyStore.readableCurrencyValue(maxFreeCashAmount, true, true, true);
					this.notificationStore.showNotification("cash-limit-exceeded", [formattedMaxCash]);
					return;
				}
				// Check if Cashmatic is linked
				if (isAndroid() && localStorage.getItem("cashmaticActive") === "1") {
					this.activeCashmatic = true;
				} else {
					this.activeCash = true;
				}
			}
			if (mode === "pos") {
				this.activeCard = true
			}
			if (mode === "other") {
				this.activeOther = true
			}
			if (mode === "customer_credit") {
				this.paymentComplete('customer_credit')
			}
			if (mode === "cash-fast") {
				if (this.userStore.isOverCashLimit) {
					let maxFreeCashAmount = this.currencyStore.currCurrency?.max_free_weekly_cash_amount || 300000;
					let formattedMaxCash = this.currencyStore.readableCurrencyValue(maxFreeCashAmount, true, true, true);
					this.notificationStore.showNotification("cash-limit-exceeded", [formattedMaxCash]);
					return;
				}
				// Check if Cashmatic is linked - if so, use Cashmatic instead of fast cash
				if (isAndroid() && localStorage.getItem("cashmaticActive") === "1") {
					this.activeCashmatic = true;
				} else {
					this.paymentComplete('cash');
				}
			}
			if (mode === "pos-fast") {
				const defaultTerminal = this.getDefaultTerminal();
				if(defaultTerminal) {
					this.startPosPayment(defaultTerminal);
				} else {
					this.activeCard = true;
				}
			}

		},
		quickStartPosFast() {
			// Used by the numpad quick-pay shortcut. On mobile this component is mounted
			// the moment the sheet opens, so terminals may still be loading; wait for them
			// (no-op if already loaded) before triggering the fast pos payment.
			this.updateBusinessTerminals(false, () => {
				this.startPayment('pos-fast');
			});
		},
		changeDutch(v) {
			if (this.chosenPaymentMode !== 2) {
				return;
			}
			this.dutchPeople = Math.trunc(v);
			this.dutchPeopleMulti = Math.max(1, Math.min(this.dutchPeople, this.dutchPeopleMulti));
			this.intentToPay = this.dutchPeople > 0 ? Math.trunc((this.toPayValue * this.dutchPeopleMulti) / this.dutchPeople) : 0;
			this.discountedItemsSplitTotal = null;
			this.paymentItemsSplitTotal = null;
		},
		changeDutchMulti(v) {
			if (this.chosenPaymentMode !== 2) {
				return;
			}
			this.dutchPeopleMulti = Math.trunc(v);
			this.intentToPay = this.dutchPeople > 0 ? Math.trunc((this.toPayValue * this.dutchPeopleMulti) / this.dutchPeople) : 0;
			this.discountedItemsSplitTotal = null;
			this.paymentItemsSplitTotal = null;
		},
		changePartial(v) {
			if (this.chosenPaymentMode !== 1) {
				return;
			}
			this.intentToPay = this.currencyStore.actualToDbValue(v);
		},
		closeBottomSheet(v) {
			if(this.activeCashmatic) {
				return;
			}
			this.$emit("toggling-popup", v);
		},
		togglingCash(v) {
			if (!v) {
				this.activeCash = false;
			}
		},
		togglingCashmatic(v) {
			if (!v) {
				let wasProcessed = this.cashmaticPaymentProcessed;
				this.activeCashmatic = false;
				this.cashmaticPaymentProcessed = false;
				if(wasProcessed) {
					this.$emit("toggling-popup", false);
				}
			}
		},
		togglingCard(v) {
			if (!v) {
				this.activeCard = false;
			}
		},
		togglingOther(v) {
			if (!v) {
				this.activeOther = false;
			}
		},
		paymentComplete(type, orderCreatedId = null) {
			if (this.loadingPayment) return;
			if (this.currentIntentToPay >= this.toPayValue) {
				this.counterStore.broadcastPaymentComplete(this.total);
			}
			if(this.activeCashmatic) {
				this.cashmaticPaymentProcessed = true;
			}
			if (this.chosenPaymentMode === 0) {
				this.loadingPayment = true;

				// Check if customer_credit payment with insufficient funds
				const isInsufficientCredit = type === 'customer_credit' &&
					this.availableCustomerCredit > 0 &&
					this.availableCustomerCredit < this.toPayValue;
				const amountRemaining = isInsufficientCredit ? this.toPayValue - this.availableCustomerCredit : 0;

				if (this.paidValue === 0 && !isInsufficientCredit) {
					// Full payment with no previous payments and sufficient credit
					this.$emit("payment-done", type, null, null, orderCreatedId, null, null, this.discountOnTotal, null, this.appliedCoupons, this.onlyTotalItem, this.paymentCompletePostLoad);
				} else if (isInsufficientCredit) {
					// Insufficient credit - use partial payment flow (multi-payment)
					let partialType = {
						type: 1,
						amount: amountRemaining
					};
					this.$emit("payment-done", type, this.availableCustomerCredit, partialType, orderCreatedId, null, null, this.discountOnTotal, null, this.appliedCoupons, false, (success) => {
						if (success) {
							// Set the partial amount for the remainder (amountRemaining is already in DB value)
							this.intentToPay = amountRemaining;
							this.forceModeAfterPayment = 1;
						}
						this.paymentCompletePostLoad();
						// Clear the flag after paymentCompletePostLoad uses it
						if (success) {
							this.forceModeAfterPayment = false;
						}
					});
				} else {
					this.$emit("payment-done", type, this.currentIntentToPay, null, orderCreatedId, null, null, this.discountOnTotal, null, this.appliedCoupons, this.onlyTotalItem, this.paymentCompletePostLoad);
				}
			} else if (this.chosenPaymentMode === 1) {
				if (this.currentIntentToPay > 0) {
					this.loadingPayment = true;
					let intentToPay = this.currentIntentToPay;

					// Handle insufficient credit for partial payments
					const isInsufficientCredit = type === 'customer_credit' && this.availableCustomerCredit > 0 && this.availableCustomerCredit < this.currentIntentToPay;
					const amountRemaining = isInsufficientCredit ? this.currentIntentToPay - this.availableCustomerCredit : 0;

					if (isInsufficientCredit) {
						intentToPay = this.availableCustomerCredit;
					}

					if (this.paidValue === 0 && this.toPayValue === intentToPay) {
						intentToPay = null;
					}

					let partialType = {
						type: 1,
						amount: intentToPay,
					}
					this.$emit("payment-done", type, intentToPay, partialType, orderCreatedId, null, null, this.discountOnTotal, null, this.appliedCoupons, false, (success) => {
						if (success && isInsufficientCredit) {
							// Show the remainder in Partial mode (amountRemaining is already in DB value)
							this.intentToPay = amountRemaining;
							this.forceModeAfterPayment = 1;
						} else if (!success) {
							this.notificationStore.showNotification("generic-fail");
						}
						this.paymentCompletePostLoad();
						if (success && isInsufficientCredit) {
							this.forceModeAfterPayment = false;
						}
					});
				} else {
					this.notificationStore.showNotification("error-no-intent-to-pay");
				}
			} else if (this.chosenPaymentMode === 2) {
				if (this.currentIntentToPay > 0) {
					this.loadingPayment = true;
					let intentToPay = this.currentIntentToPay;

					// Handle insufficient credit for dutch payments
					const isInsufficientCredit = type === 'customer_credit' && this.availableCustomerCredit > 0 && this.availableCustomerCredit < this.currentIntentToPay;
					const creditRemainder = isInsufficientCredit ? this.currentIntentToPay - this.availableCustomerCredit : 0;

					if (isInsufficientCredit) {
						intentToPay = this.availableCustomerCredit;
					}

					if (this.paidValue === 0 && this.toPayValue === intentToPay) {
						intentToPay = null;
					}

					const discountedSplit = this.discountedItemsSplitTotal !== null && this.discountedItemsSplitTotal > 0 && this.discountedItemsSplitTotal < this.intentToPay;
					const partialSplit = this.paymentItemsSplitTotal !== null && this.paymentItemsSplitTotal > 0 && this.paymentItemsSplitTotal < this.intentToPay;
					let baseForPartial = discountedSplit ? this.discountedItemsSplitTotal : this.intentToPay;
					let amountRemaining = partialSplit ? baseForPartial - this.paymentItemsSplitTotal : 0;
					let partialType = null;
					let dutchPeople = Math.max(this.dutchPeople - this.dutchPeopleMulti, 1);
					if (partialSplit) {
						partialType = {
							type: 1,
							amount: amountRemaining,
							dutchPeople: dutchPeople,
						}
					} else {
						partialType = {
							type: 2,
							dutchPeople: dutchPeople,
						}
					}

					let dutchPeoplePayload = {
						remain: dutchPeople,
						paid: this.dutchPeopleMulti
					}
					let discountPartial = null;
					if (discountedSplit) {
						discountPartial = this.intentToPay - this.discountedItemsSplitTotal;
					}
					this.$emit("payment-done", type, intentToPay, partialType, orderCreatedId, null, dutchPeoplePayload, this.discountOnTotal, discountPartial, this.appliedCoupons, false, (success) => {
						if (success) {
							this.dutchPeople = dutchPeople;
							this.dutchPeopleMulti = 1;
							if (partialSplit) {
								// Set remainder for partial split (amountRemaining is already in DB value)
								this.intentToPay = amountRemaining;
								this.forceModeAfterPayment = 1;
							} else if (isInsufficientCredit) {
								// Show the remainder in Partial mode for insufficient credit (creditRemainder is already in DB value)
								this.intentToPay = creditRemainder;
								this.forceModeAfterPayment = 1;
							}
						} else {
							this.notificationStore.showNotification("generic-fail");
						}
						this.paymentCompletePostLoad();
						if (success && (partialSplit || isInsufficientCredit)) {
							this.forceModeAfterPayment = false;
						}
					});
				} else {
					this.notificationStore.showNotification("error-no-intent-to-pay");
				}
			} else if (this.chosenPaymentMode === 3) {
				if (this.currentIntentToPay > 0) {
					this.loadingPayment = true;
					let intentToPay = this.currentIntentToPay;

					// Handle insufficient credit for split payments
					const isInsufficientCredit = type === 'customer_credit' && this.availableCustomerCredit > 0 && this.availableCustomerCredit < this.currentIntentToPay;
					const creditRemainder = isInsufficientCredit ? this.currentIntentToPay - this.availableCustomerCredit : 0;

					if (isInsufficientCredit) {
						intentToPay = this.availableCustomerCredit;
					}

					if (this.paidValue === 0 && this.toPayValue === intentToPay) {
						intentToPay = null;
					}

					let itemsRedeemed = [];
					this.selectedItems.forEach(item => {
						itemsRedeemed.push({
							id: item.id,
							order_item_id: item.order_item_id,
							menu_item_id: item.menu_item_id,
							quantity: item.selected,
							order_id: item.order_id ? item.order_id : null,
						});
					});
					let partialType = {
						type: 3,
					}
					const discountedSplit = this.discountedItemsSplitTotal !== null && this.discountedItemsSplitTotal > 0 && this.discountedItemsSplitTotal < this.itemsSplitSelectedTotal;
					const partialSplit = this.paymentItemsSplitTotal !== null && this.paymentItemsSplitTotal > 0 && this.paymentItemsSplitTotal < this.itemsSplitSelectedTotal;
					let baseForPartial = discountedSplit ? this.discountedItemsSplitTotal : this.itemsSplitSelectedTotal;
					if (partialSplit) {
						partialType = {
							type: 3,
							amount: baseForPartial - this.paymentItemsSplitTotal,
						}
					}

					let discountPartial = null;
					if (discountedSplit) {
						let valueToDiscount = this.itemsSplitSelectedTotal > this.toPayValue ? this.toPayValue : this.itemsSplitSelectedTotal;
						discountPartial = valueToDiscount - this.discountedItemsSplitTotal;
					}
					this.$emit("payment-done", type, intentToPay, partialType, orderCreatedId, itemsRedeemed, null, this.discountOnTotal, discountPartial, this.appliedCoupons, false, (success) => {
						if (success) {
							if (partialSplit) {
								this.ghostSelectedTotal = baseForPartial - this.paymentItemsSplitTotal;
							} else {
								this.ghostSelectedTotal = 0;
							}
							this.selectedItems.forEach(item => {
								item.selected = 0;
							});
							if (isInsufficientCredit) {
								// Show the remainder in Partial mode for insufficient credit (creditRemainder is already in DB value)
								this.intentToPay = creditRemainder;
								this.forceModeAfterPayment = 1;
							}
						} else {
							this.notificationStore.showNotification("generic-fail");
						}
						this.paymentCompletePostLoad();
						if (success && isInsufficientCredit) {
							this.forceModeAfterPayment = false;
						}
					});
				} else {
					this.notificationStore.showNotification("error-no-intent-to-pay");
				}
			}
		},
		paymentCompletePostLoad() {
			this.loadingPayment = false;
			if (!this.isRegistry) {
				this.counterStore.selectedCustomer = null;
				this.counterStore.customerNotEditable = false;
				this.counterStore.noPayLater = false;
				this.discountedItemsSplitTotal = null;
				this.paymentItemsSplitTotal = null;
				this.discountOnTotal = 0;
				this.discountMode = null;
			}
			this.counterStore.invoiceAdditionalData.purchase_order = null;
			this.counterStore.invoiceAdditionalData.payment_due_date = null;
			if (this.forceModeAfterPayment) {
				this.changePaymentMode(this.forceModeAfterPayment);
			}

			this.counterStore.externalPaymentIntentEnd("OK");
		},
		startPosPayment(terminalId) {
			if (this.$refs["pos-container"]) {
				let discountPartial = null;
				let itemsRedeemed = null;
				if (this.chosenPaymentMode === 3) {
					itemsRedeemed = [];
					this.selectedItems.forEach(item => {
						itemsRedeemed.push({
							id: item.id,
							order_item_id: item.order_item_id,
							menu_item_id: item.menu_item_id,
							quantity: item.selected,
							order_id: item.order_id ? item.order_id : null,
						});
					});
					const discountedSplit = this.discountedItemsSplitTotal !== null && this.discountedItemsSplitTotal > 0 && this.discountedItemsSplitTotal < this.itemsSplitSelectedTotal;
					if (discountedSplit) {
						let partialToDiscount = this.itemsSplitSelectedTotal > this.toPayValue ?
							this.toPayValue : this.itemsSplitSelectedTotal;
						discountPartial = partialToDiscount - this.discountedItemsSplitTotal;
					}
				} else if (this.chosenPaymentMode === 2) {
					const discountedSplit = this.discountedItemsSplitTotal !== null && this.discountedItemsSplitTotal > 0 && this.discountedItemsSplitTotal < this.intentToPay;
					if (discountedSplit) {
						discountPartial = this.intentToPay - this.discountedItemsSplitTotal;
					}
				}

				let dutchPeople = null;
				if (this.chosenPaymentMode === 2) {
					dutchPeople = {
						remain: Math.max(this.dutchPeople - this.dutchPeopleMulti, 1),
						paid: this.dutchPeopleMulti
					};
				}
				if (this.currentIntentToPay > 0) {
					if (this.isCounter) {
						this.loadingPayment = true;
						let requestingPayment = 'stripe';
						if(terminalId && terminalId?.startsWith && (terminalId?.startsWith('dojo') || terminalId?.startsWith('pax'))) {
							requestingPayment = 'external';
						}
						this.counterStore.createOrder(this.currentIntentToPay, this.discountOnTotal, this.appliedCoupons, itemsRedeemed, dutchPeople, requestingPayment, this.onlyTotalItem, (result, orderId) => {
							this.loadingPayment = false;
							if (result === "success") {
								// Set before any async work
								this.ordersActionsStore.setExpectingFiscalPrint();
								this.$refs["pos-container"].sendPayment(this.currentIntentToPay, terminalId, [orderId], null, dutchPeople, this.chosenPaymentMode, null, discountPartial, null, this.skipTipping, this.onlyTotalItem);
							} else if (result === "total_too_high") {
								this.notificationStore.showNotification("total-too-high");
							} else if (result === "total_too_low") {
								let formattedMinAmount = this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.min_stripe_amount);
								this.notificationStore.showNotification("total-too-low", [formattedMinAmount]);
							} else {
								this.notificationStore.showNotification("generic-error");
							}
						});
					} else {
						let paymentMode = this.chosenPaymentMode;
						if (paymentMode === 0 && this.paidValue !== 0) {
							paymentMode = 1;
						}

						this.ordersActionsStore.setExpectingFiscalPrint();
						if(this.counterStore.creditTopUpMode && this.counterStore.registryEditingCustomer) {
							// Credit top-up mode - invoiceData.credit_topup flag is handled in PhysicalPosContainer
							this.$refs["pos-container"].sendPayment(this.currentIntentToPay, terminalId, null, null, null, paymentMode, null, null, null, this.skipTipping, false);
						} else {
							let orderIds = this.isOrders && this.ordersActionsStore.ordersPayment ? this.ordersActionsStore.ordersPayment.map(order => order.order_id) : null;
							let printSingleItem = this.onlyTotalItem && this.chosenPaymentMode === 0;
							this.$refs["pos-container"].sendPayment(this.currentIntentToPay, terminalId, orderIds, itemsRedeemed, dutchPeople, paymentMode, this.discountOnTotal, discountPartial, this.appliedCoupons, this.skipTipping, printSingleItem);
						}
					}
				} else {
					this.notificationStore.showNotification("error-no-intent-to-pay");
					this.loadingPayment = false;
				}
			}
		},
		getDefaultTerminal() {
			let terminalId = null;
			if (this.terminals.length > 0) {
				let lastTerminalId = localStorage.getItem("lastTerminalId");
				if (lastTerminalId && this.terminals.find(t => t.terminal_id === lastTerminalId)) {
					terminalId = lastTerminalId;
				} else {
					terminalId = this.terminals[0].terminal_id;
				}
				localStorage.setItem("lastTerminalId", terminalId);
			}
			return terminalId;
		},
		emitDeletedCustomer(c) {
			this.$emit("deleted-customer", c);
		},
		emitDeletedCompany(c) {
			this.$emit("deleted-company", c);
		},
		openPersonSheet() {
			this.$refs["customer-picker"].newPersonSheet = true;
		},
		openCompanySheet() {
			this.$refs["customer-picker"].newCompanySheet = true;
		},
		personHandleOpenPicker() {
			this.customerPicker = true;
		},
		companyHandleOpenPicker() {
			this.customerPicker = true;
			this.$nextTick(() => {
				if (this.$refs["customer-picker"] && this.$refs["customer-picker"].$refs["customer-type-switch"]) {
					this.$refs["customer-picker"].$refs["customer-type-switch"].isChecked = true;
					this.$refs["customer-picker"].people = false;
				}
			});
		},
		toggleItemProductExplain(active) {
			if (!active) {
				this.activeExplainItemProducts = null;
			}
		},
		addedLocalTerminal(newTerminalId, callback) {
			if(newTerminalId === "tap_phone") {
				this.updateBusinessTerminals(true, callback);
			}
		},
		updateBusinessTerminals(force = false, callback = null) {
			this.userStore.getBusinessTerminals(true, (terminals) => {
				let newTerminals = [];
				if (this.userStore.paxTerminals) {
					this.userStore.paxTerminals.forEach(t => {
						const tCopy = {...t};
							tCopy.terminal_id = "pax" + t.terminal_id;
						newTerminals.push(tCopy);
					});
				}
				if (this.userStore.dojoTerminals) {
					this.userStore.dojoTerminals.forEach(t => {
						const tCopy = {...t};
							tCopy.terminal_id = "dojo" + t.terminal_id;
						newTerminals.push(tCopy);
					});
				}
				terminals.forEach(t => {
					newTerminals.push(t);
				});
				this.terminals = newTerminals;
				if (callback) {
					callback();
				}
			}, force);
		},
		discountToggle() {
			if (!this.noTotalDiscount) {
				if (!this.userStore.checkOrderDiscountAllowed) {
					this.notificationStore.showNotification('permission-denied-order-discount');
					return;
				}
				this.splitPayEdit = true;
				this.discountMode = discountModes.total;
			}
		}
	},
	created() {
		this.updateBusinessTerminals(false,  () => {
			if (this.counterStore.externalPaymentIntentData) {
				this.activeCard = true;
				this.$nextTick(() => this.startPosPayment("tap_phone"));
			}
		});
	},
	mounted() {
		this.loadingPayment = false;
	},
	watch: {
		"userStore.currBusinessId": function (newVal, oldVal) {
			if (newVal != null && newVal !== oldVal) {
				this.updateBusinessTerminals();
			}
		},
		active(newValue, oldValue) {
			if (newValue) {
				let resetIntentToPay = true;
				let resetDutch = true;
				let resetSelectedItems = true;
				if (this.ordersStore.ctaIsPaymentPartial && this.ordersStore.ctaIsPaymentPartial.type) {
					this.chosenPaymentMode = this.ordersStore.ctaIsPaymentPartial.type;
					if (this.ordersStore.ctaIsPaymentPartial.type === 1 && this.ordersStore.ctaIsPaymentPartial.hasOwnProperty("amount")) {
						this.intentToPay = Math.min(this.toPayValue, this.ordersStore.ctaIsPaymentPartial.amount);
						resetIntentToPay = false;
						if (this.ordersStore.ctaIsPaymentPartial.hasOwnProperty("dutchPeople")) {
							this.dutchPeople = this.ordersStore.ctaIsPaymentPartial.dutchPeople;
							this.dutchPeopleMulti = 1;
							this.forceModeAfterPayment = 2;
							resetDutch = false;
						}
					}
					if (this.ordersStore.ctaIsPaymentPartial.type === 2 && this.ordersStore.ctaIsPaymentPartial.hasOwnProperty("dutchPeople")) {
						this.changeDutch(this.ordersStore.ctaIsPaymentPartial.dutchPeople);
						resetIntentToPay = false;
						resetDutch = false;
					}
					if (this.ordersStore.ctaIsPaymentPartial.type === 3 && this.ordersStore.ctaIsPaymentPartial.hasOwnProperty("amount")) {
						this.selectedItems = [];
						this.discountedItemsSplitTotal = null;
						this.paymentItemsSplitTotal = null;
						this.ghostSelectedTotal = this.ordersStore.ctaIsPaymentPartial.amount;
						resetSelectedItems = false;
					}
					this.ctaIsPaymentPartial = null;
				} else {
					this.chosenPaymentMode = 0;
					this.discountOnTotal = 0;
					this.discountMode = null;
					this.appliedCoupons = null;
				}
				this.onlyTotalItem = false;
				if (resetIntentToPay) {
					this.intentToPay = 0;
				}
				if (resetDutch) {
					this.dutchPeople = this.defaultDutchPeople ? this.defaultDutchPeople : 2;
					this.dutchPeople = Math.max(this.dutchPeople, 1);
					this.dutchPeopleMulti = 1;
				}
				if (resetSelectedItems) {
					this.selectedItems = [];
					this.discountedItemsSplitTotal = null;
					this.paymentItemsSplitTotal = null;
					this.ghostSelectedTotal = 0;
				}
			}
		},
		toPayValue(newValue, oldValue) {
			if (newValue && this.chosenPaymentMode === 2) {
				this.intentToPay = this.dutchPeople > 0 ? Math.trunc((this.toPayValue * this.dutchPeopleMulti) / this.dutchPeople) : 0;
			}
		}
	}
}
</script>

<style scoped lang="scss">
.container-payment-status {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 5px;

	.alignment-cta {
		display: flex;
		width: 66.666%;
		gap: 5px;
		@media (max-width: 520px) {
			flex-direction: column;
			width: calc(100% / 2);
			min-height: 165px;
		}
		@media (max-width: 450px) {
			min-height: 108px;
		}
	}

	.column-status {

		&.clickable {
			border: 1px solid var(--color-primary);

			&:hover {
				cursor: pointer;
			}
		}

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: calc(100% / 3);
		min-height: 80px;
		padding: 10px;
		box-shadow: inset 0 1px 4px var(--color-box-shadow-3);
		border-radius: 13px;
		overflow: hidden;
		background-color: var(--color-alpha-1);
		@media (max-width: 520px) {
			width: calc(100% / 2);
			min-height: 165px;
		}
		@media (max-width: 450px) {
			min-height: 108px;
			padding: 5px 10px;
		}

		&-name {
			font-size: 14px;
		}

		&-value {
			font-size: 24px;
			font-weight: 500;
			margin-top: 4px;
		}

		&.status-paid {
			background-color: var(--color-display-alpha-green);
			width: calc(100% / 2);
			@media (max-width: 520px) {
				width: 100%;
				min-height: 80px;
			}
			@media (max-width: 450px) {
				min-height: 50px;
			}
		}

		&.status-topay {
			background-color: var(--color-display-alpha-red);
			width: calc(100% / 2);

			&.discounted {
				display: flex;
				position: relative;
				justify-content: flex-end;
				align-items: flex-end;

				.split-row-label {
					color: var(--txt-1);
					font-size: 10px;
					line-height: 20px;
					text-align: right;
					margin: 4px 0 4px 0;
					position: absolute;
					top: 4px;
					left: 12px;
				}

				.full-total {
					color: var(--color-txt-1);
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
					align-items: center;
					text-decoration: line-through;
				}

				.discounted-total {
					font-size: 22px;
					font-weight: 500;
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
					align-items: center;
				}

				.icon-discount {
					:deep(svg) {
						width: 18px;
						height: 18px;

						.fill {
							fill: var(--color-txt);
						}

						.stroke {
							stroke: var(--color-txt);
						}
					}
				}

				.full-total-container, .discounted-total-container {
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
					align-items: center;
				}
			}

			@media (max-width: 520px) {
				width: 100%;
				min-height: 80px;
			}
			@media (max-width: 450px) {
				min-height: 50px;
			}
		}

		.column-status-name {
			@include truncateString(1);
			width: 100%;
			text-align: center;

			@media (max-width: 450px) {
				font-size: 13px;
			}
		}

		.column-status-value {
			@include truncateString(1);
			width: 100%;
			text-align: center;

			@media (max-width: 450px) {
				font-size: 18px;
			}
		}
	}
}

.document-type-container {
	padding: 10px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.document-type-title {
		font-size: 14px;
	}

}

.payment-type-container {
	margin-bottom: 10px;
	border-radius: 13px;

	.wrapper-tabbar {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		.botton-tabbar {
			display: flex;
			height: 44px;
			padding: 10px 12px;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			flex: 1 0 0;
			background: var(--color-fill-button);
			box-shadow: 0 -1px 2px 0 var(--color-box-shadow-3) inset, 1px 1px 2px 0 var(--color-box-shadow-1) inset;
			cursor: pointer;
			transition: background 0.2s linear;
			@include truncateString(1);
			@media (max-width: 420px) {
				padding: 10px 6px 8px;
			}
			@media (max-width: 370px) {
				height: 46px;
			}

			p {
				font-size: 12px;
				line-height: 18px;
				max-width: 100%;
				@include truncateString();
				@media (max-width: 470px) {
					font-size: 10px;
				}
			}

			&:first-child {
				border-radius: 13px;
				margin-right: 5px;
				position: relative;

				&:after {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: calc(100% - 2px);
					height: calc(100% - 2px);
					border-radius: 13px;
					border: 1px solid transparent;
					transition: border 0.2s $transition;
					pointer-events: none;
				}
			}

			&:nth-child(2) {
				border-top-left-radius: 13px;
				border-bottom-left-radius: 13px;
			}

			&:last-child {
				border-top-right-radius: 13px;
				border-bottom-right-radius: 13px;
			}

			.indicator-bar {
				height: 7px;
				flex-shrink: 0;
				align-self: stretch;
				border-radius: 13px;
				background-color: var(--color-alpha-2);
				box-shadow: 0 1px 2px 0 var(--color-box-shadow-3) inset;
				transition: background 0.2s linear;
			}

			&:hover {
				background-color: var(--color-fill-button-hover);

				.indicator-bar {
					background-color: var(--color-alpha-dropdown-1);
				}
			}

			&.active {
				background-color: var(--color-fill-button-active);
				box-shadow: 0 -1px 4px 0 var(--color-box-shadow-1) inset, 1px 1px 3px 0 var(--color-box-shadow-3) inset;

				p {
					font-weight: 500;
				}

				.indicator-bar {
					background: var(--color-secondary);
					box-shadow: 0 1px 2px 0 var(--color-box-shadow-3) inset;
				}

				&:hover {
					background-color: var(--color-alpha-dropdown-1);
				}
			}

			&:first-child.border {
				box-shadow: 0 -1px 2px 0 var(--color-box-shadow-3) inset, 1px 1px 2px 0 var(--color-box-shadow-1) inset;
				&:after {
					border: 1px solid var(--color-secondary);
				}
			}
		}
	}
}

.payment-advance-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-end;
	--split-gap: 20px;
	gap: var(--split-gap);
	flex-wrap: wrap;

	@media (max-width: 480px) {
		--split-gap: 12px;
	}

	@media (max-width: 370px) {
		--split-gap: 8px;
	}
}

.payment-dutch-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.row-dutch {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: flex-end;
		width: 100%;
		--dutch-gap: 20px;
		gap: var(--dutch-gap);
		flex-wrap: wrap;

		@media (max-width: 480px) {
			--dutch-gap: 12px;
		}

		@media (max-width: 370px) {
			--dutch-gap: 8px;
		}

		.num-people-container {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			height: 50px;
			cursor: pointer;

			@media (max-width: 450px) {
				flex-direction: column-reverse;
				gap: 4px;
			}

			p {
				font-size: 14px;
				font-weight: 500;
				margin-right: 6px;
				color: var(--color-primary);
				@include truncateString(1);
			}

			.num-people {
				display: flex;
				justify-content: center;
				align-items: center;

				&:deep(svg) {
					width: 18px;
					height: 18px;

					.fill {
						fill: var(--color-primary);
					}

					.stroke {
						stroke: var(--color-primary);
					}
				}
			}
		}


		.dutch-value-container {

			.dutch-label {
				color: var(--txt-1);
				font-size: 10px;
				line-height: 15px;
				margin-bottom: 5px;

				span {
					font-size: 10px;
					line-height: 15px;
					margin-right: 4px;
					color: var(--color-txt);
				}
			}

			.dutch-value {
				font-size: 22px;
				font-weight: 500;
				min-width: 160px;
				text-align: right;
				padding: 8px 12px;
				border-radius: 13px;
				box-shadow: inset 1px 2px 4px var(--color-alpha-3);
				background-color: var(--color-alpha-1);
				height: 50px;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				@media (max-width: 450px) {
					font-size: 18px;
					min-width: 130px;
				}

				@media (max-width: 390px) {
					font-size: 16px;
					min-width: 100px;
				}
			}

		}

	}
}

.payment-split-container {
	display: flex;
	flex-direction: column;
	position: relative;

	&:after {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 13px;
		box-shadow: inset 1px 1px 4px var(--color-box-shadow-3);
		pointer-events: none;

	}

	.payment-split-row {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		overflow-x: auto;
		min-height: 64px;
		padding: 0;

		&::-webkit-scrollbar {
			background-color: var(--color-fill-button);
			height: 8px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: var(--color-alpha-3);
			border: 1px solid var(--color-fill-button);
			border-radius: 10px;
		}

		.split-row-items {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			padding: 0 12px;
			gap: 8px;
		}

		&.split-row-choose {
			padding: 4px 0 8px;
			background-color: var(--color-bg-primary-2);
			@media (max-width: 450px) {
				padding: 0 0 8px;
			}
		}

		&.split-row-chosen {
			background-color: var(--color-bg);
			width: calc(100% - 160px);
			border-bottom-left-radius: 13px;
			border-bottom-right-radius: 13px;
			padding: 0 0 8px;

			@media (max-width: 450px) {
				width: calc(100% - 130px);
				padding: 0 0 8px;
			}
		}
	}


	.payment-split-row-title {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 4px 12px 0;

		.split-title {
			font-size: 11px;
			color: var(--color-txt-1);
			min-height: 23px;
			display: flex;
			align-items: center;
		}

		.split-overflow {
			display: flex;
			flex-direction: row;
			align-items: center;
			font-size: 11px;

			span {
				font-size: 11px;
				font-weight: 500;
				color: $danger;
				margin-left: 4px;
			}

		}

		&.split-row-choose-title {
			background-color: var(--color-bg-primary-2);
			border-top-left-radius: 13px;
			border-top-right-radius: 13px;
		}

		&.split-row-chosen-title {
			background-color: var(--color-bg);
		}
	}

	.payment-row-wrapper {
		display: flex;
		flex-direction: row;
		align-items: stretch;
		width: 100%;
		padding: 4px 8px 8px 0;
		border-radius: 0 0 13px 13px;
		background-color: var(--color-bg);
		position: relative;
		@media (max-width: 450px) {
			padding: 0 8px 8px 0;
		}

		&:after {
			content: "";
			position: absolute;
			top: 0;
			right: 168px;
			width: 10px;
			height: 100%;
			background: linear-gradient(90deg, var(--color-bg-alpha-0) 0%, var(--color-bg) 100%);
			@media (max-width: 450px) {
				right: 138px;
			}
		}
	}

}

.split-row-value {
	position: relative;
	min-height: 64px;
	width: 160px;
	padding: 8px 12px;
	border-radius: 13px;
	box-shadow: inset 1px 2px 4px var(--color-box-shadow-3);
	background-color: var(--color-bg-primary-2);
	display: flex;
	flex-direction: column;
	justify-content: center;
	transition: background-color 0.2s $transition;

	.split-row-label {
		color: var(--txt-1);
		font-size: 10px;
		line-height: 15px;
		text-align: right;
		margin-bottom: 4px;
		position: absolute;
		top: 4px;
		left: 12px;
	}

	.full-total {
		font-size: 22px;
		font-weight: 500;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}

	.discounted-total-container, .full-total-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;

		.icon-discount {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 6px;

			:deep(svg) {
				width: 15px;
				height: 15px;

				.fill {
					fill: var(--txt-1);
				}

				.stroke {
					stroke: var(--txt-1);
				}
			}
		}

	}

	.full-total-container {
		.icon-discount {
			:deep(svg) {
				width: 18px;
				height: 18px;

				.fill {
					fill: var(--color-txt);
				}

				.stroke {
					stroke: var(--color-txt);
				}
			}
		}
	}

	.discounted-total, .selected-total {
		font-size: 14px;
		text-decoration: line-through;
		color: var(--color-txt-1);
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}

	.selected-total {
		color: var(--color-txt-2);
	}

	&.clickable {
		cursor: pointer;
		background-color: var(--color-alpha-3);
	}

	&.discounted {
		background-color: rgba(40, 237, 191, 0.12);
	}

	@media (max-width: 450px) {
		width: 130px;

		.full-total {
			font-size: 18px;
		}
	}
}

.loader-container {
	width: 100%;
	height: 170px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	@media (max-width: 450px) {
		height: 140px;
	}
}

.payment-buttons {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.payment-button {
		width: 100%;
		min-height: 50px;
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
		user-select: none;
		box-shadow: 0 2px 3px var(--color-box-shadow-2);
		transition: box-shadow 0.2s $transition;
		font-size: 18px;
		border: 1px solid var(--color-primary);
		@media (max-width: 450px) {
			min-height: 40px;
		}

		p {
			color: $primary;
		}

		&:hover {
			box-shadow: 0 2px 3px var(--color-box-shadow-1);
		}

		&.credit-button {
			min-height: 100px;
		}
	}

	.main-payment-buttons {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;

		.payment-button {
			width: calc(50% - 5px);
			min-height: 100px;
			display: flex;
			@media (max-width: 450px) {
				min-height: 80px;
			}

			&.full-width {
				width: 100%;
			}

			p {
				width: calc(100% - 56px);
				display: flex;
				justify-content: center;
			}

			.payment-shortcut {
				width: 50px;
				height: 90px;
				border-radius: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				box-shadow: 0 2px 3px rgba(7, 82, 163, 0.15);
				border: 1px solid $primary;
				margin: 0 5px;
				@media (max-width: 450px) {
					height: 70px;
				}

				:deep(svg) {
					width: 18px;

					.fill {
						fill: var(--color-svg-primary);
					}

					.stroke {
						stroke: var(--color-svg-primary);
					}

				}
			}

			&.cash-over-limit {
				background-color: rgba(255, 87, 87, 0.1);
				border: 2px solid rgba(255, 87, 87, 0.5);
				cursor: default;
				opacity: .8;

				p {
					color: #d32f2f;
				}

				.payment-shortcut {
					border: 1px solid #d32f2f;
					box-shadow: 0 2px 3px rgba(211, 47, 47, 0.15);

					:deep(svg) {
						.fill {
							fill: #d32f2f;
						}
						.stroke {
							stroke: #d32f2f;
						}
					}
				}

				&:hover {
					box-shadow: 0 2px 3px rgba(255, 87, 87, 0.3);
				}
			}
		}
	}
}

.wrapper-buttons-add {
	height: 100%;
	width: 100%;

	.row-button-add {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		gap: 4px;
	}

	.base-button {
		height: 40px;
		width: calc(50% - 5px);
		background-color: var(--color-fill-button);
		border: none;

		&:hover {
			box-shadow: none;
			background-color: var(--color-fill-button-hover);
		}
	}
}

:deep(.dropdown-container) {
	.dropdown {
		.dropdown-content {
			margin-top: 0;
			padding: 0 0 10px 0;
		}
	}
}

.shares-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
}
</style>
